export default __webpack_public_path__ + "static/media/ic-crops-watermelon.af752fe3.svg";